import { Typography } from '@mui/material';

import { useAgencyHomePromoMessageConfig } from '../hooks/useApiQueries';
import { PromoMessageSlot } from '../types/promoMessage';
import { getFranchise } from '../utils';

interface AgencyHomePromoMessageProps {
  franchiseId?: string;
  /**
   * Emplacement d'affichage. Chaque emplacement a sa propre configuration :
   * la page de garde dispose de toute la largeur, les affaires en cours d'une
   * carte étroite. Par défaut `home` pour rester compatible avec les appels
   * existants.
   */
  slot?: PromoMessageSlot;
}

const AgencyHomePromoMessage = ({ franchiseId, slot = 'home' }: AgencyHomePromoMessageProps) => {
  const { data: messageData, isLoading } = useAgencyHomePromoMessageConfig(slot);

  // Si loading ou pas de données actives, ne rien afficher
  if (isLoading || !messageData?.active || !messageData?.config) {
    return null;
  }

  const config = messageData.config;

  // Chercher un message personnalisé pour cette franchise (par nom logique : 82 et 83 = Simplicicar)
  let messageToDisplay = config.default_message;

  if (franchiseId && config.franchise_messages && config.franchise_messages.length > 0) {
    const currentFranchiseName = getFranchise(franchiseId);
    const franchiseMessage = config.franchise_messages.find(
      (fm: { franchise_id?: string; franchise_name?: string; message: string }) => {
        if (fm.franchise_id !== undefined) {
          return getFranchise(fm.franchise_id) === currentFranchiseName;
        }
        // Ancien format : comparaison par nom
        const fmName = (fm as { franchise_name?: string }).franchise_name;
        return fmName != null && fmName.toLowerCase() === currentFranchiseName.toLowerCase();
      },
    );

    if (franchiseMessage) {
      messageToDisplay = franchiseMessage.message;
    }
  }

  // Si le message est vide, ne rien afficher
  if (!messageToDisplay || messageToDisplay.trim() === '') {
    return null;
  }

  return (
    <Typography
      variant="body2"
      gutterBottom
      align="center"
      sx={{ marginBottom: (theme) => theme.spacing(1) }}
      dangerouslySetInnerHTML={{ __html: messageToDisplay }}
    />
  );
};

export default AgencyHomePromoMessage;
